module.exports = __webpack_public_path__ + "img/USPbond.8af6967a.svg";